import Head from 'next/head';
import React from 'react';

export const MetaStatic: React.FC<{ jsonLds: Record<string, unknown>[] }> = ({ jsonLds }) => (
  <Head>
    {jsonLds.map((jsonLd, index) => (
      <script
        // eslint-disable-next-line react/no-array-index-key
        key={`json-lds-${index}`}
        type="application/ld+json"
        // JSON-LD : JSON.stringify échappe le contenu ; on encode `<` en `\u003c` pour empêcher toute
        // évasion `</script>` si un champ venu de l'API (ex. `website.name` des blocs
        // `/api/seo/common/*`) portait du HTML (idiome PersonLd, généralisé B6_12).
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd).replace(/</g, '\\u003c') }}
      />
    ))}
  </Head>
);
